<template>
  <div class="tipps-container">
    <h2>Nachhaltigkeitstipps</h2>
    <div class="content">
      Es gibt sehr viele Tipps wie jeder den Alltag nachhaltiger gestalten kann. 
      Hier sind nur einige genannt, wer noch mehr wissen möchte findet viele 
      Informationen beim Nachhaltigen Warenkorb: 
      <a href="https://www.nachhaltiger-warenkorb.de/" target="_blank">https://www.nachhaltiger-warenkorb.de/</a>

      <p>&nbsp;</p>

      <div class="tipp">
        <div class="tipp-header" @click="opnv = !opnv">
          <i class="fa fa-chevron-right expand-icon" :class="{ expanded : opnv }"/>
          ÖPNV
        </div>
        <div class="tipp-content" v-show="opnv">
          Durch eine höhere Anzahl von Mitfahrern ist der ÖPNV häufig umweltfreundlicher als das eigene Auto. 
          Außerdem spart man sich dadurch Kosten für Versicherung, Sprit, Reparaturen etc.
          <ul>
            <li>Für Fernreisen bietet sich die Bahn an, auch Fernbusse bedienen viele wichtige Ziele in Deutschland</li>
            <li>Die Kosten für den öffentlichen Nahverkehr gleichen sich häufig durch die wegfallenden Kosten für den eigenen PKW aus</li>
            <li>Die Zeit in öffentlichen Verkehrsmitteln kann man, anders als im Auto, für andere Dinge nutzen</li>
            <li>Wird doch einmal ein Auto benötigt bietet sich Car-Sharing an: man bezahlt nur für die Zeit, die man ein Auto nutzt</li>
            <li>Für größere Transporte bietet ein Lastenrad eine umweltfreundliche Alternative</li>
          </ul>
        </div>
      </div>

      <div class="tipp">
        <div class="tipp-header" @click="trash = !trash">
          <i class="fa fa-chevron-right expand-icon" :class="{ expanded : trash }"/>
          Verpackungsmüll
        </div>
        <div class="tipp-content" v-show="trash">
          Verpackungen verbrauchen wertvolle Ressourcen – nur um danach sofort wieder weggeworfen zu werden, 
          das muss aber nicht sein.
          <ul>
            <li>Wer Dinge selbst herstellt spart sich oft Verpackungsmüll</li>
            <li>Es gibt mittlerweile spezialisierte Geschäfte, die ihre Waren unverpackt anbieten. So kannst du auch selbst entscheiden, wie viel du von einem Produkt kaufen möchtest.</li>
            <li>Auch immer mehr Geschäfte z.B. Metzgereien geben dir ihre Waren in mitgebrachte Gefäße
Plastikbeutel für Obst sind meistens überflüssig und werden oft daheim auch sofort weggeworfen</li>
            <li>Statt Wasser aus Flaschen kannst du problemlos auf Leitungswasser umsteigen – das am besten kontrollierte Lebensmitteln in Deutschland.</li>
          </ul>
        </div>
      </div>

      <div class="tipp">
        <div class="tipp-header" @click="renewables = !renewables">
          <i class="fa fa-chevron-right expand-icon" :class="{ expanded : renewables }"/>
          Strom aus erneuerbarer Energie
        </div>
        <div class="tipp-content" v-show="renewables">
          Die Zeiten in denen Strom aus erneuerbaren Energien teurer war sind schon lange vorbei, 
          mittlerweile ist er oft sogar günstiger!
          <ul>
            <li>Wichtig ist ausschließlich Öko-Strom zu beziehen und keinen Mix mit Kohlestrom</li>
            <li>Strom aus erneuerbaren Energien wird häufig auch bei regionalen Erzeugern angeboten</li>
            <li>In vielen Fällen lohnt sich auch eine eigene Photovoltaik Anlage auf dem Dach</li>
            <li>
              Am besten ist immer noch der Strom der nicht verbraucht wird, das geht zum Teil ganz einfach:
              <ul>
                <li>Energiesparlampen bevorzugen, höhere Lebensdauer bevorzugen</li>
                <li>Geräte die nicht benötigt werden nicht im Stand By-Modus eingeschaltet lassen</li>
                <li>Geräte abschalten die nicht benötigt werden</li>
                <li>Geräte möglichst lange nutzen und beim Neukauf auf geringen Verbrauch achten</li>
                <li>Nur Geräte kaufen, die man wirklich benötigt da die Herstellung oft mehr Energie verbraucht als die Benutzung!</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>

      <div class="tipp">
        <div class="tipp-header" @click="sharing = !sharing">
          <i class="fa fa-chevron-right expand-icon" :class="{ expanded : sharing }"/>
          Sharing-Angebote
        </div>
        <div class="tipp-content" v-show="sharing">
          Auch für die Herstellung von Produkten werden viele Ressourcen verbraucht. Indem man Dinge mit anderen teilt 
          oder wiederverwendet kann man hier viel einsparen – und auch der Geldbeutel profitiert. 
          <ul>
            <li>Dinge die man selten benutzt wie z.B. Werkzeug kann man sich oft beim freundlichen Nachbarn leihen. Zur Organisation gibt es mittlerweile ebenfalls verschiedene Apps.</li>
            <li>Second-Hand Kleidung ist deutlich besser als ihr Ruf – so lässt sich auch mit besserem Gewissen shoppen</li>
            <li>Autos stehen den größten Teil des Tages nur herum, durch Car-Sharing bezahlt man dagegen nur dann für ein Auto, wenn man es wirklich braucht</li>
            <li>Die Foodsharing Bewegung ermöglicht es, gute Lebensmittel an andere weiterzugeben anstatt sie wegzuwerfen.</li>
            <li>Durch Mitfahrgelegenheiten kommt man günstig von A nach B. Schon einmal über eine Fahrgemeinschaft zur Arbeit nachgedacht?</li>
          </ul>
        </div>
      </div>

      <div class="tipp">
        <div class="tipp-header" @click="regional = !regional">
          <i class="fa fa-chevron-right expand-icon" :class="{ expanded : regional }"/>
          Regionale Produkte
        </div>
        <div class="tipp-content" v-show="regional">
          Regionale Produkte haben meistens eine bessere Klimabilanz als weitgereiste – und sichern lokale Arbeitsplätze.
          <ul>
            <li>Der Begriff regional ist nicht gesetzlich geschützt – einige Supermärkte geben aber den Ursprung genauer an z.B. das Bundesland</li>
            <li>Bei einem lokalen Markt kann man die Verkäufer direkt fragen woher die Produkte kommen</li>
            <li>Auch Hofläden regionaler Landwirte bieten häufig eine Vielzahl eigener Produkte</li>
          </ul>
        </div>
      </div>

      <div class="tipp">
        <div class="tipp-header" @click="microplastic = !microplastic">
          <i class="fa fa-chevron-right expand-icon" :class="{ expanded : microplastic }"/>
          Mikroplastik vermeiden
        </div>
        <div class="tipp-content" v-show="microplastic">
          Mikroplastik gelangt in immer weitere Teile der Umwelt – und auch auf unsere Teller. Die Folgen sind bisher noch nicht absehbar.
          <ul>
            <li>Die Smartphone-App <i>Codecheck</i> informiert durch einen Barcode-Scan über alle bedenklichen Inhaltsstoffe, ob und welche Art von Mikroplastik enthalten ist, und schlägt Alternativen vor.</li>
            <li>Zertifizierte Naturkosmetik enthält kein Mikroplastik</li>
            <li>Auch wenn es manchmal umständlich ist: Plastik gehört in die Tonne nicht in die Natur!</li>
            <li>Das meiste Mikroplastik entsteht durch Reifenabrieb, daher achte hier auf hohe Haltbarkeit</li>
            <li>Vermeide Kleidung aus Polyester, Acryl und Elasthan – beim Waschen lösen sich viele kleine Plastikteile aus ihnen heraus</li>
          </ul>
        </div>
      </div>

      <div class="tipp">
        <div class="tipp-header" @click="mobil = !mobil">
          <i class="fa fa-chevron-right expand-icon" :class="{ expanded : mobil }"/>
          Mobil aus eigener Kraft
        </div>
        <div class="tipp-content" v-show="mobil">
          Wenn du dich mit eigener Muskelkraft fortbewegst, tust du nicht nur der Umwelt und deinem Geldbeutel einen gefallen, sondern auch deiner Gesundheit.
          <ul>
            <li>Für größere Transporte wie z.B. den Wocheneinkauf bieten sich Fahrradtaschen oder ein Lastenrad an</li>
            <li>Spezielle Kleidung hilft dir auch bei Regen mit dem Fahrrad trocken zu bleiben</li>
            <li>Viele Städte bieten mittlerweile Mietfahrräder an, so bist du auch an anderen Orten mobil</li>
            <li>Auch wenn es „uncool“ aussieht: ein Fahrradhelm schützt</li>
            <li>Tretroller können oft auch problemlos in Bus und Bahn mitgenommen werden, so kommt man trotzdem schnell und umweltfreundlich von Tür zu Tür</li>
          </ul>
        </div>
      </div>

      <div class="tipp">
        <div class="tipp-header" @click="renovation = !renovation">
          <i class="fa fa-chevron-right expand-icon" :class="{ expanded : renovation }"/>
          Ökologische Sanierung
        </div>
        <div class="tipp-content" v-show="renovation">
          Durch ökologische Sanierung des Eigenheims können oft große Mengen Heizenergie eingespart werden – das schont das Klima und das Bankkonto.
          <ul>
            <li>Für Fernreisen bietet sich die Bahn an, auch Fernbusse bedienen viele wichtige Ziele in DeutschlandÜberprüfe die Isolierung deiner Fester und Türen. Poröse undichte Isolierungen können günstig ausgetauscht werden</li>
            <li>Heiz-Checks und Förderratgeber findest du unter anderem unter  <a href="https://www.co2online.de" target="_blank">www.co2online.de</a> und <a href="http://www.heizspiegel.de" target="_blank">www.heizspiegel.de</a>.</li>
            <li>
              Auch beim Heizen gilt: sparen hilft am meisten. Hier einige Beispiele wie es funktioniert
              <ul>
                <li>Heize Räume nicht unnötig auf. Im Schlafzimmer halten wir uns beispielsweise tagsüber kaum auf</li>
                <li>22° C reichen häufig für eine angenehme Temperatur aus (das entspricht Stufe 3 am Thermostat)</li>
                <li>Es hilft nicht eine höhere Stufe auf der Heizung einzustellen, dadurch steigt die Temperatur nicht schneller sondern nur höher</li>
                <li>Beim kurzen Stoßlüften geht weniger Wärme verloren, als beim dauerhaften Kippen der Fenster</li>
                <li>Drehe die Heizung ab, wenn du dich länger nicht in Räumen aufhältst z.B. Nachts oder im Urlaub</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>

      <div class="tipp">
        <div class="tipp-header" @click="flying = !flying">
          <i class="fa fa-chevron-right expand-icon" :class="{ expanded : flying }"/>
          Flugreisen vermeiden
        </div>
        <div class="tipp-content" v-show="flying">
          Beim Fliegen wird viel Energie verbraucht um überhaupt abheben zu können, dadurch entstehen schnell mehrere Tonnen Treibhausgase. So kannst du das vielleicht vermeiden:
          <ul>
            <li>Inlandsflüge sind unnötig: auch mit Bus und Bahn kommt man überall in Deutschland hin. Die Zeitersparnis beim Fliegen wird durch die An- und Abreise häufig aufgefressen</li>
            <li>Der Weg ist das Ziel: statt die Anreise zum Urlaubsort als Verschwendung zu sehen, kann man den Weg dorthin ebenfalls nutzen um abzuschalten.</li>
            <li>Wenn ein Flug sich gar nicht vermeiden lässt: es gibt eine Vielzahl an Anbietern, die die entstandenen Treibhausgase durch Projekte (z. B. Baumpflanzungen) für einen verträglichen Preis ausgleichen</li>
          </ul>
        </div>
      </div>

      <div class="tipp">
        <div class="tipp-header" @click="organic = !organic">
          <i class="fa fa-chevron-right expand-icon" :class="{ expanded : organic }"/>
          Bioprodukte
        </div>
        <div class="tipp-content" v-show="organic">
          Auch wenn immer wieder daran gezweifelt wird: wo Bio drauf steht ist auch fast immer Bio drin, 
          das wird durch unabhängige Stellen geprüft. Neben mehr Tierwohl und großen Vorteilen für die Natur, 
          sorgt die ökologische Anbauweise für mehr Arbeitsplätze.
          <ul>
            <li>Es gibt unterschiedliche Bio-Siegel die jeweils verschieden strenge Anforderungen haben, weitere Infos findest du hier: <a href="https://www.oekolandbau.de/bio-siegel/" target="_blank">https://www.oekolandbau.de/bio-siegel/</a></li>
            <li>Durch das Verbot von Pflanzenschutzmitteln helfen sie die Insekten- und Tierwelt zu schonen</li>
            <li>Auf Bio-Produkten wird automatisch auch immer das Herkunftsland angegeben</li>
            <li>Durch das steigende Bio-Angebot in Supermärkten und Discountern ist es einfacher und bezahlbarer geworden solche Produkte zu kaufen</li>
            <li>Nicht nur Lebensmittel können biologisch erzeugt sein, auch Kosmetik und auch Kleidung aus Öko-Anbau sind zu haben</li>
          </ul>
        </div>
      </div>

      <div class="tipp">
        <div class="tipp-header" @click="fairtrade = !fairtrade">
          <i class="fa fa-chevron-right expand-icon" :class="{ expanded : fairtrade }"/>
          Produkte aus Fairem Handel
        </div>
        <div class="tipp-content" v-show="fairtrade">
          Gerade bei Produkte aus so genannten Entwicklungsländern ist nicht immer klar, unter welchen Bedingungen 
          sie erzeugt wurden. Bei Produkten aus zertifiziertem fairen Handel ist garantiert, dass die Erzeuger einen 
          fairen Preis bekommen und keine Kinderarbeit stattgefunden hat.
          <ul>
            <li>In so genannten Eine-Welt-Geschäften gibt es ausschließlich fair hergestellte Produkte</li>
            <li>Faire Produkte sind durch verschiedene Siegel gekennzeichnet, weitere Informationen findest du hier: <a href="https://www.nachhaltiger-warenkorb.de/siegel/fairtrade/" target="_blank">https://www.nachhaltiger-warenkorb.de/siegel/fairtrade/</a></li>
            <li>Neben Lebensmitteln wie  Kaffee, Schokolade und Tee gibt es noch einige weitere Produkte die aus fairem Handel zu kaufen sind: z.B. Blumen, Kleidung oder Sportbälle</li>
          </ul>
        </div>
      </div>

      <div class="tipp">
        <div class="tipp-header" @click="meat = !meat">
          <i class="fa fa-chevron-right expand-icon" :class="{ expanded : meat }"/>
          Reduktion Fleisch & Fisch
        </div>
        <div class="tipp-content" v-show="meat">
          Da die Erzeugung der Futtermittel für die Tierhaltung viele Ressourcen und Platz verbraucht, ist es eine 
          wichtige Nachhaltigkeitsmaßnahme weniger Fleisch zu verzehren. Daneben sind viele Fischbestände stark 
          überstrapaziert, weshalb auch hier Mäßigung empfohlen wird.
          <ul>
            <li>Auch aus gesundheitlichen Gründen ist es sinnvoll, den Fleischverzehr zu reduzieren und zum traditionellen Sonntagsbraten zurückzukehren</li>
            <li>Wenn Fleisch auf den Tisch kommt sollte es möglichst bio-zertifiziert sein, dieses ist meist weniger mit Antibiotika-Rückständen belastet und unter tierfreundlicheren Bedingungen erzeugt</li>
            <li>Wer weniger Fleisch isst, kann ganz neue leckere pflanzliche Lebensmittel entdecken</li>
            <li>Beim Kauf von Fisch ist darauf zu achten, keine überfischten Arten auszuwählen. Eine Übersicht findest du z.B. hier: <a href="https://www.greenpeace.de/themen/meere/app-fuer-nachhaltigen-fisch" target="_blank">https://www.greenpeace.de/themen/meere/app-fuer-nachhaltigen-fisch</a></li>
          </ul>
        </div>
      </div>

      <div class="tipp">
        <div class="tipp-header" @click="fuel = !fuel">
          <i class="fa fa-chevron-right expand-icon" :class="{ expanded : fuel }"/>
          Spritverbrauch reduzieren
        </div>
        <div class="tipp-content" v-show="fuel">
          Gerade in ländlichen Gegenden geht es manchmal nicht ohne eigenes Auto. Doch auch dann gibt es Möglichkeiten nachhaltiger zu handeln.
          <ul>
            <li>Bei Kurzstrecken das Auto öfter mal stehen lassen, gerade in der Stadt ist man so oft schneller – und spart sich die Parkplatzsuche</li>
            <li>Beim Kauf eines Neuwagens sollte Wert auf einen geringen Spritverbrauch gelegt werden</li>
            <li>Auch die Fahrweise hat Einfluss auf den Spritverbrauch: wer niedrigtourig fährt spart biszu  25% Kraftstoff</li>
            <li>Automobilvereine bieten Fahrtrainings für eine umweltbewusste Fahrweise</li>
            <li>Der Kauf eines gebrauchten Fahrzeugs schont wertvolle Ressourcen und den Geldbeutel</li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Tipps',
  data() {
    return {
      opnv: false,
      trash: false,
      renewables: false,
      sharing: false,
      regional: false,
      microplastic: false,
      mobil: false,
      renovation: false,
      flying: false,
      organic: false,
      fairtrade: false,
      meat: false,
      fuel: false,
    }
  },
  methods: {
    name() {

    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.tipps-container {
  height: 100%;
  @include gradient;
  padding-top: 50px;
}

.content {
  color: $dark;
  min-height: 100vh;

  a {
    color: $secondary;
  }
}

.tipp {
  margin: 10px 0px;
  .tipp-header {
    font-weight: bold;
    font-size: 16pt;
    cursor: pointer;
    
    i {
      font-size: 12pt;
    }
  }
}

.expand-icon {
  transition: transform 0.2s;
}
.expanded {
  transform: rotate(90deg);
}
</style>